import React, { useEffect, useState } from 'react';
import { useApiCaller } from '../../utils/ApiUtilities';
import { getPublicStatsUrl } from '../../utils/UrlUtilities';

// Baseline added to the real registered-user count so the public "Active Users"
// figure reflects total reach. Shown value = USER_BASE_COUNT + actual users.
const USER_BASE_COUNT = 496;

// Public platform totals — big colored numbers with captions, purple 3D lift on hover.
export default function StatsFlashcards() {
    const CallApi = useApiCaller();
    const [stats, setStats] = useState(null);

    useEffect(() => {
        let cancelled = false;
        (async () => {
            const res = await CallApi({ url: getPublicStatsUrl(), method: 'GET', token: false });
            if (!cancelled && res.success) setStats(res.data);
        })();
        return () => { cancelled = true; };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (!stats) return null;

    const activeUsers = USER_BASE_COUNT + Number(stats.total_users || 0);
    const cards = [
        { value: stats.total_questions, label: 'MCQ Question Bank', color: '#a21caf' },
        { value: stats.total_quizzes, label: 'Free Model Tests', color: '#10b981' },
        { value: activeUsers, label: 'Active Users', color: '#e0a42a' },
    ];

    return (
        <div className="my-5">
            <div className="row g-3 justify-content-center">
                {cards.map((c) => (
                    <div key={c.label} className="col-md-4">
                        <div
                            className="kp-card-hover text-center"
                            style={{
                                backgroundColor: '#ffffff',
                                border: '1px solid #ede9fe',
                                borderRadius: '0.75rem',
                                padding: '2rem 1rem',
                            }}
                        >
                            <div style={{ fontSize: '2.75rem', fontWeight: 800, color: c.color, lineHeight: 1 }}>
                                {Number(c.value || 0).toLocaleString()}+
                            </div>
                            <div style={{ marginTop: '0.75rem', color: '#4b5563', fontWeight: 600 }}>{c.label}</div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
